export default __webpack_public_path__ + "static/springandsummer (14)-4a975657f16e7108637805e7b20d4585.jpeg";